<!--
单页面示例：字段较多、两列布局；
-->
<template>
  <iframe  width="100%" style="border: 0px;" height="100%" :src="'//'+util.apiBasePath+'/jpcp/project/update/'+id+'?noback='+noback+'&tbName='+tbName">

  </iframe> 
</template>
<script>
  import ScrollRightFrame from '../../../../components/scroll-right-frame'
  import util from '../../../../libs/util'
  export default {
    name: 'project-update',
    components: {ScrollRightFrame},
    data() {
      return {
        util:util,
        id:'',
        noback:'',
        tbName:''
      }
    },
    watch: {
      '$route':function(to, from) {
        }
    },
    mounted(){   
    this.id =this.$route.query.id;
    this.noback =this.$route.query.noback;
    this.tbName =this.$route.query.tbName;
    const _than =this;
    window.goback =function(){
       util.routerBack(_than,"/");
    }
    window.tip =function(msg){
        _than.$notify.success({title: '成功', message: msg});
    }

     window.tipError =function(msg){
        _than.$notify.error({title: '失败', message: msg});
    }
    },
    methods: {

    }
  }
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/custom/components/jpcp/project/project-update.vue